var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactivated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 9.55002V13.7167C1.66602 15.625 3.20768 17.1667 5.11602 17.1667H14.8743C16.7827 17.1667 18.3327 15.6167 18.3327 13.7084V9.55002C18.3327 8.99169 17.8827 8.54169 17.3243 8.54169H2.67435C2.11602 8.54169 1.66602 8.99169 1.66602 9.55002ZM6.66602 14.375H4.99935C4.65768 14.375 4.37435 14.0917 4.37435 13.75C4.37435 13.4084 4.65768 13.125 4.99935 13.125H6.66602C7.00768 13.125 7.29102 13.4084 7.29102 13.75C7.29102 14.0917 7.00768 14.375 6.66602 14.375ZM12.0827 14.375H8.74935C8.40768 14.375 8.12435 14.0917 8.12435 13.75C8.12435 13.4084 8.40768 13.125 8.74935 13.125H12.0827C12.4243 13.125 12.7077 13.4084 12.7077 13.75C12.7077 14.0917 12.4243 14.375 12.0827 14.375Z",
    fill: "url(#paint0_linear_38_11177)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2493 3.84165V6.28331C11.2493 6.84165 10.7993 7.29165 10.241 7.29165H2.67435C2.10768 7.29165 1.66602 6.82498 1.66602 6.26665C1.67435 5.32498 2.04935 4.46665 2.67435 3.84165C3.29935 3.21665 4.16602 2.83331 5.11602 2.83331H10.241C10.7993 2.83331 11.2493 3.28331 11.2493 3.84165Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6417 1.66669H14.1917C13.1333 1.66669 12.5 2.30002 12.5 3.35835V5.80835C12.5 6.86669 13.1333 7.50002 14.1917 7.50002H16.6417C17.7 7.50002 18.3333 6.86669 18.3333 5.80835V3.35835C18.3333 2.30002 17.7 1.66669 16.6417 1.66669ZM16.95 5.40835C17.0417 5.51669 17.0917 5.63335 17.0917 5.77502C17.0917 5.89169 17.0417 6.02502 16.95 6.11669C16.7583 6.30835 16.4333 6.30835 16.2417 6.11669L15.4167 5.29169L14.6 6.12502C14.4083 6.31669 14.0833 6.31669 13.8833 6.11669C13.6917 5.92502 13.6917 5.60002 13.8833 5.40835L14.7167 4.59169L13.8917 3.76669C13.7 3.57502 13.6917 3.25002 13.8833 3.05002C14.075 2.85002 14.4 2.85835 14.6 3.05835L15.4167 3.88335L16.25 3.05002C16.4417 2.85835 16.7667 2.85835 16.9583 3.05002C17.05 3.15835 17.0917 3.28335 17.1 3.41669C17.1 3.53335 17.05 3.66669 16.9667 3.76669L16.1333 4.60002L16.95 5.40835Z",
    fill: "url(#paint1_linear_38_11177)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_11177",
    x1: 9.99935,
    y1: 8.54169,
    x2: 9.99935,
    y2: 17.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_11177",
    x1: 15.4167,
    y1: 1.66669,
    x2: 15.4167,
    y2: 7.50002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.ce068cfa3ee0ecaa31ca601946a80cd9.svg";
export { ForwardRef as ReactComponent };